import {Component, HostBinding, inject, Input} from '@angular/core';
import {BlockElementImage} from 'app/entities/blockElements/blockElementImage';
import {NavigationService} from 'app/services/navigation.service';
import {BlockElementAbstractComponent} from 'app/components/blocks/components/blockElementCore';
import {BlockElementIcon} from 'app/entities/blockElements/blockElementIcon';

@Component({
  selector: 'app-block-element-image',
  templateUrl: 'item.html',
  styleUrls: ['item.scss'],
})
export class BlockElementImageComponent extends BlockElementAbstractComponent<BlockElementImage> {
  @HostBinding('class')
  get classes() {
    const classes = super.classes;

    // @todo rework classes assignment

    classes.push('block-icon-wrapper');

    if (this.blockElement.icon?.settings?.size === 'small') {
      classes.push('block-icon-wrapper-small');
    }

    if (this.blockElement.icon?.settings?.size === 'medium') {
      classes.push('block-icon-wrapper-medium');
    }

    if (this.blockElement.icon?.settings?.size === 'big') {
      classes.push('block-icon-wrapper-big');
    }

    return classes;
  }

  getInnerClasses() {
    const classes = [];

    if (this.blockElement.background?.background) {
      classes.push(`background-${this.blockElement.background.background}`);
    }

    if (this.blockElement.action) {
      classes.push('ion-activatable');
      classes.push('block-ripple-parent');
    }

    return classes;
  }
}
